module.exports = __webpack_public_path__ + "img/img8.7f2f717f.jpg";